import Login from '../components/SetupLogin.js';
export default {
  init() {
    Login();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/login.js